const SHARE_ACCESS_MESSAGES = {
    ORDER_DELETED: '摄影师已撤回该相册，无法继续选图',
    ORDER_NOT_FOUND: '该选图分享不存在',
    ALBUM_NOT_FOUND: '该选图分享不存在',
    ALBUM_SHARE_EXPIRED: '该选图分享已过期',
    ALBUM_SHARE_INACTIVE: '摄影师已关闭该选图分享',
};

export function getShareAccessError(error) {
    const status = error?.response?.status || 0;
    const code = error?.response?.data?.code || '';
    const message = SHARE_ACCESS_MESSAGES[code]
        || (status === 410 ? '该选图分享已失效' : null);
    return {
        status,
        code,
        message,
        terminal: Boolean(message),
    };
}
